var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property, query, queryAll } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { repeat } from 'lit/directives/repeat.js';
import { LitElement, html, css } from 'lit';
import { parseContextArrDisp as parseContextArr, doSubmit, customElement, stringDecoder, numberDecoder, fetchApiData, PIC, loadPage, objectDecoder, booleanDecoder } from '../Internals';
let PICDispatch = class PICDispatch extends LitElement {
    constructor() {
        super(...arguments);
        this.globMode = '';
        this.viewMode = '';
        this.curDate = '';
        this.term = '';
        this.truckGrp = '';
        this.displayMode_ = 'expanded';
        this.topViewScrollTop = -1;
        this.calendarScrollTop = -1;
        this.customFields_ = [];
        this.nosep_ = false;
        this.orders = [];
        this.trucks = [];
        this.hoverElm = null;
        this.assignedOrders = [];
        this.contextMap = new Map();
        this.tmpCol = getComputedStyle(document.documentElement).getPropertyValue("--tblRowHoverColor");
        this.timeMap = new Map();
        this.time = [];
        this.apiOpt = null;
        this.saveScrollTop = false;
        this.hasReceivedData = false;
        this.colCount = 1;
        this.retryHandle = 4;
    }
    connectedCallback() {
        super.connectedCallback();
        this.time = [];
        for (let i = 0; i < 48; i++) {
            let tmp = { id: i, txt: (Math.floor(i / 2) + '').padStart(2, '0') + ':' + ((i % 2 == 0) ? '00' : '30') };
            this.time.push(tmp);
            this.timeMap.set(tmp.txt.replace(':', ''), i + 1);
        }
        this.apiOpt = {
            postBody: {
                mode: 'getOrdersAll',
                data: {
                    globalMode: this.globMode,
                    viewMode: this.viewMode,
                    curDate: this.curDate,
                    termName: this.term,
                    truckGrp: this.truckGrp
                }
            }
        };
        this.curDateObj_ = new Date(this.curDate);
        this.curDateObj_.setHours(0, 0, 0, 0);
        this.refreshData();
    }
    static get styles() {
        const defaultStyle = css `
            .heightcontainer{
                display: flex;
                flex-direction: column;
                height: calc(100vh - 170px);
            }
            .clearSearchBTN{
                position: absolute;
                right: 0px;
                top: 15px;
                background-color: var(--buttonColor);
                color: white;
                cursor: pointer;
                height: 1.35rem;
                white-space: nowrap;
                line-height: 1.35rem;
                padding-left: 2px;
                padding-right: 2px;
            }
            .clearSearchBTN:hover{
                background: var(--buttonHoverColor);
                color: black;
            }
            .grid-container{
                display: grid;
                overflow: auto;
                margin-top: 0.8rem;
                height: 57vh;
                /*max-height: 80vh;*/
                /* contextmenu placement behaviour */
                position: relative;
                /*grid-column-gap: 0.2rem;*/
                /*max-height: 58vh;*/
            }
            .top-grid{
                display: grid;
                overflow-y: auto;
                max-height: 21vh;
                grid-template-rows: 2rem;
                border-bottom: 1px solid black;
                overflow-x: hidden;
                /* contextmenu placement behaviour */
                position: relative;
            }   
            .top-grid-hdr{
                display: inline-block;
                color: white;
                background-color: var(--headerColor);
                grid-row: 1 / 3;
                grid-column: 1 / 26;
                position: sticky;
                z-index: 1;
                top: 0;
                padding: 5px;
            }
            .top-grid-hdr-fld{
                text-align: center;
                position: sticky;
                /*overflow-wrap: break-word;*/
                color: white; 
                z-index:2; 
                font-size: 11px;
                line-height: 1rem;
                text-align: center;
                top: 0;
            }
            .top-grid-hdr-inp{
                z-index: 2;
                position: sticky;
                top: 2rem;
                display: flex;
                justify-content: center;
                font-size: 13px;
                height: var(--dispatch-filter-height, 23px);
                margin: var(--dispatch-filter-margin, 0 0 2px 0);
            }
            .top-grid-order{
                display: grid;
                text-align: center;
                border-left: 1px solid black;
                border-right: 1px solid black;
                overflow-wrap: break-word;
                background-color: var(--tableMain, var(--toms-tableMain));
            }
            .top-grid-order:not(:last-child){
                border-bottom: 1px solid black;
            }
            .top-grid-order:hover{
                color: var(--trHoverText);
                background-color: var(--tblRowHoverColor);
            }
            /*grid-template-columns: 8% repeat(3, 4%) 3% 3% repeat(13, 4%) 3% 4% 3% repeat(3, 4%);*/
            .top-grid-columns{
                grid-template-columns: 8% repeat(3, 4%) 4% repeat(13, 4%) 4% 4% 4% repeat(3, 4%);
            }
            .top-grid-columns .cell{
                display: flex;
                justify-content: center;
                align-content: center;
                flex-direction: column;
                font-size: 11px;
            }
            .top-grid-columns .cell.svg{
                display: inline-grid;
            }
            .pic-svg{
                height: 2em;
                width: 2em;
                margin: 0 0 0 0.5em;
                cursor: pointer;
            }
            .fld_search{
                width: 89%;
                padding-right: 0px;
                padding-left: 0px;
            }
            .driverHdr {
                display: inline-block;
                color: white;
                background-color: var(--headerColor);
                grid-row-start: 0;
                grid-row-end: 1;
                position: sticky;
                z-index: 4;
                top: 0;
                padding: 5px;
                cursor: pointer;
                text-align: center;
                /*border-bottom: 1px solid #E3E4E4;*/
                /*width: 8rem;*/
            }
            .driverTime {
                display: inline-block;
                color: white;
                background-color: var(--headerColor);
                /*width: 3rem;*/
                grid-column: 1 / 2;
            }
            .driverTimeSlot{
                background-color: var(--tableMain, var(--toms-tableMain));
                display: inline-block;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-right: 1px solid black;
                /*width: 8rem;
                margin-right: 10px;
                padding-left: 4px;
                padding-right: 4px;*/
            }
            .driverTimeSlot.noBottom{
                border-bottom: unset;
            }
            .driverTimeSlot.whitebg{
                background-color: white;
            }
            .order{
                border: 1px solid black;
                transition: width 1s;
                overflow-wrap: break-word;
            }
            .order.last{
                width: calc(100% - 10px);
            }
            .draggable:hover{
                cursor: grab;
            }
            .driverPlaceHolder {
                display: inline-block;
                background-color: var(--headerColor);
            }
            .rowDiv{
                display: block;
            }
            .dataRow:hover{
                background-color: var(--tblRowHoverColor);
                color: var(--trHoverText);
            }
        `;
        return css `
            ${defaultStyle}
        `;
    }
    /* scroll handling */
    willUpdate() {
        if (this.calendarGridContainer && this.saveScrollTop) {
            this.calendarScrollTop = this.calendarGridContainer.scrollTop;
            this.topViewScrollTop = this.topViewGridContainer.scrollTop;
        }
    }
    /* saves scrollstate of both scrollable DIV's */
    setSaveScrolltop() {
        var _a, _b;
        //only update scrollpos after first apiresponse
        if (!this.hasReceivedData)
            return;
        if (!this.topViewScrollTopLightElm) {
            this.topViewScrollTopLightElm = document.createElement('input');
            this.topViewScrollTopLightElm.type = 'hidden';
            this.topViewScrollTopLightElm.name = 'topViewScrollTop';
            (_a = document.body.querySelector('#PICForm')) === null || _a === void 0 ? void 0 : _a.appendChild(this.topViewScrollTopLightElm);
        }
        if (!this.calendarScrollTopLightElm) {
            this.calendarScrollTopLightElm = document.createElement('input');
            this.calendarScrollTopLightElm.type = 'hidden';
            this.calendarScrollTopLightElm.name = 'calendarScrollTop';
            (_b = document.body.querySelector('#PICForm')) === null || _b === void 0 ? void 0 : _b.appendChild(this.calendarScrollTopLightElm);
        }
        this.topViewScrollTopLightElm.value = this.topViewGridContainer.scrollTop + '';
        this.topViewScrollTop = this.topViewGridContainer.scrollTop;
        this.calendarScrollTopLightElm.value = this.calendarGridContainer.scrollTop + '';
        this.calendarScrollTop = this.calendarGridContainer.scrollTop;
    }
    updated() {
        if (this.calendarScrollTop != -1) {
            this.calendarGridContainer.scrollTop = this.calendarScrollTop;
            if (this.topViewScrollTop != -1)
                this.topViewGridContainer.scrollTop = this.topViewScrollTop;
        }
        else {
            if (this.assignedOrders.length > 0)
                this.saveScrollTop = true;
            this.scrollTarget.scrollIntoView();
        }
        this.setSaveScrolltop();
        for (let idx = 0; idx < this.searchFields.length; idx++) {
            let elm = this.searchFields[idx];
            if (elm.value)
                if (elm.value.length > 0) {
                    elm.dispatchEvent(new Event('keyup'));
                }
        }
        getSavedFilterFields(this.searchFields);
        function getSavedFilterFields(table) {
            let savedFilterRows;
            let tmp;
            let savedFilterRow;
            tmp = sessionStorage.getItem('webSearchTable-Saved-filterRows');
            if (tmp) {
                savedFilterRows = JSON.parse(tmp);
                if (savedFilterRows) {
                    savedFilterRow = savedFilterRows.find((curFilterRow) => curFilterRow.user == PIC.user && curFilterRow.subwin == PIC.subwin && curFilterRow.tableId == 'dispatchTop');
                }
                if (savedFilterRow) {
                    for (let idx = 0; idx < table.length; idx++) {
                        let elm = table[idx];
                        elm.value = savedFilterRow.filterRow[idx];
                        elm.dispatchEvent(new CustomEvent('keyup'));
                    }
                }
            }
        }
    }
    /* drag & drop helpers */
    allowDrop(e) {
        /* allows old compents to drop stuff,
        TODO: needs dndcheck.p implementation in api*/
        let sess = PIC.sessionCode.split('.')[1];
        if (sess && !e.dataTransfer.types.includes('prevent') && e.dataTransfer.types.includes(sess)) {
            e.preventDefault();
        }
        /* prevent drops originating by selecting text and then dragging the DIV and prevent drops originating from other session */
        else if (!e.dataTransfer.types.includes('prevent') && e.dataTransfer.types.includes(PIC.getInstance.sessionCode)) {
            e.preventDefault();
        }
    }
    handleDrag(e) {
        e.dataTransfer.setData('actno', e.target.getAttribute("data-actno"));
        e.dataTransfer.setData('seqno', e.target.getAttribute("data-seqno"));
        /* dragover can only see the types of data, set sessioncode to prevent dragging to other windows */
        e.dataTransfer.setData(PIC.getInstance.sessionCode, '');
        /* Killed security to please the masters - Disptach -> dispatch */
        e.dataTransfer.setData(PIC.sessionCode.split('.')[1], '');
    }
    preventDrag(e) {
        /* prevent drags started by marking text of locked order and then dragging the DIV */
        e.dataTransfer.setData('prevent', '');
    }
    handleDragEnd(e) {
        let ref = this;
        if (["copy", "move"].includes(e.dataTransfer.dropEffect)) {
            setTimeout(() => { ref.refreshData(); }, 1500);
        }
    }
    handleDrop(e) {
        var _a, _b, _c;
        e.preventDefault();
        this.hoverElm.style.backgroundColor = "";
        if (e.dataTransfer) {
            let dataList = (_b = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData("di")) === null || _b === void 0 ? void 0 : _b.split("_");
            let picUserId = (_c = e.dataTransfer) === null || _c === void 0 ? void 0 : _c.getData("picsec");
            let act, seq;
            if (e.dataTransfer.getData('actno')) {
                act = e.dataTransfer.getData("actno");
                seq = e.dataTransfer.getData("seqno");
            }
            else if (dataList && dataList.length > 1) {
                act = dataList[0];
                seq = dataList[1];
            }
            if (act && seq) {
                let ti = e.target.getAttribute('data-time');
                let lic = e.target.getAttribute('data-license');
                let tmp = {
                    postBody: {
                        mode: 'assignOrder',
                        data: {
                            actNo: parseInt(act),
                            seqNo: parseInt(seq),
                            time: ti,
                            curDate: this.globVars.curDate,
                            license: lic
                        }
                    }
                };
                return fetchApiData('/toms/spedition/speditionapi', tmp).then((data) => {
                    console.log(data[0]);
                    if (data[0].result == 200) {
                        this.refreshData();
                    }
                    else if (data[0].result == 400) {
                    }
                    else {
                        alert('API returned ' + data[0].result + ' handling is not implemented.');
                    }
                });
            }
        }
    }
    dragEnter(e) {
        if (e.target) {
            e.target.style.backgroundColor = this.tmpCol;
            this.hoverElm = e.target;
        }
    }
    ;
    dragLeave(e) {
        if (e.target) {
            e.target.style.backgroundColor = "";
        }
    }
    ;
    getGlobTruckByLicense(iLicense) {
        return this.trucks.filter(t => { return t.licensePlate.toUpperCase() == iLicense.toUpperCase(); })[0];
    }
    /* Render helpers */ /*  'Truck', */
    renderTopOrderHdr() {
        let thArr = ['Reference ID', 'Orderer', 'Invoice Ref.', 'Transport Type', 'Status', 'Delivery Date', 'Delivery Window', 'Transport Length', 'Equipment ID', 'Size/Type', 'Chassis', 'Cargo Weight (KG)', 'DGS/ADR', 'Pick-Up', 'Gate Ref', 'Delivery Place', 'Turn-in', 'Gate Ref', 'Gross Margin', 'Internal Note', 'Booker', 'Documents', 'Prints', 'Notification'];
        let dispRef = this;
        return html `
            <div class="top-grid-hdr">&nbsp</div>
            ${repeat(thArr, (header) => header, (header, index) => renderHeader(header, index))}
            `;
        function renderHeader(headerText, index) {
            return html `
                <div class="top-grid-hdr-fld" style="grid-area: 1 / ${index + 1} / 2 / ${index + 2};" title = ${headerText == 'CW (KG)' ? 'Cargo Weight (KG)' : headerText}>${headerText}</div>
                <div class="top-grid-hdr-inp" style="grid-area: 2 / ${index + 1} / 3 / ${index + 2};">${renderSearchHdr(index)}</div>
            `;
        }
        function renderSearchHdr(index) {
            return html `
                <input type="text"
                    ?disabled=${index > 20}
                    class="fld_search ${index} top-grid-hdr-inp-field"
                    autocomplete="off"
                    @keyup=${(e) => dispRef.gridSearch(e.target, index)}
                    placeholder="Search"
                >
            `;
        }
    }
    gridSearch(inputFld, selectId) {
        var _a, _b, _c;
        let filterTxt, rowCollection, cell, i, txtValue;
        filterTxt = inputFld.value.toUpperCase();
        rowCollection = this.topOrders;
        if (isNaN(selectId)) {
            for (i = 1; i < rowCollection.length; i++) {
                cell = (_a = rowCollection[i]) === null || _a === void 0 ? void 0 : _a.children[selectId];
                if (cell) {
                    txtValue = cell.textContent || cell.innerText;
                    if (txtValue.toUpperCase().indexOf(filterTxt) > -1) {
                        rowCollection[i].style.display = "";
                    }
                    else {
                        rowCollection[i].style.display = "none";
                    }
                }
            }
        }
        else {
            let filterRow, j;
            filterRow = this.topSearch;
            let newRowsIdx = -1; //start of "table"
            for (i = 0; i < filterRow.length; i++) { // 0 - 25
                //if filter txt empty then next, except for first
                filterTxt = ((_b = filterRow[i]) === null || _b === void 0 ? void 0 : _b.firstElementChild).value.toUpperCase();
                if (!filterTxt && i != 0)
                    continue;
                //for each row in data
                for (j = 0; j < rowCollection.length; j++) { // 0-11
                    //cell corresponding to filter
                    cell = rowCollection[j].children[i];
                    //if cell is empty then do not display
                    if (!cell || !cell.textContent) {
                        rowCollection[j].style.display = "none";
                    }
                    //if first filter, always show all
                    if (i == 0) {
                        rowCollection[j].style.display = "";
                    }
                    //if display none, skip
                    if (rowCollection[j].style.display)
                        continue;
                    //filter vs cell value
                    txtValue = (cell === null || cell === void 0 ? void 0 : cell.textContent) || cell.innerText;
                    let filterRow = defaultSearch(filterTxt, txtValue);
                    rowCollection[j].style.display = filterRow ? "" : "none";
                    //reset grid to new area
                    if (rowCollection[j].style.display != 'none') {
                        newRowsIdx++;
                        /*    (rowCollection[j] as HTMLDivElement).style.gridArea = `${newRowsIdx} / 1 / ${newRowsIdx + 1} / 26`*/
                    }
                }
                ;
            }
            ;
            //does nothing now
            let oldRows = Number(getComputedStyle(this.shadowRoot.getElementById('topgrid')).getPropertyValue('--numJobs'));
            if (oldRows !== newRowsIdx) {
                (_c = this.shadowRoot.getElementById('topgrid')) === null || _c === void 0 ? void 0 : _c.style.setProperty('--numJobs', newRowsIdx + '');
            }
        }
        saveFilterFields(this.searchFields);
        function defaultSearch(filterText, tableText) {
            return tableText.toLowerCase().startsWith(filterText.toLowerCase());
        }
        ;
        /* persist filter text */
        function saveFilterFields(table) {
            var _a;
            let filterRow;
            let cells = [];
            for (let idx = 0; idx < table.length; idx++) {
                let elm = table[idx];
                if (elm.value) {
                    cells.push(elm.value);
                }
                else {
                    cells.push('');
                }
            }
            let savedFilterRows;
            let tmp;
            let foundFilter = -1;
            filterRow = {
                user: (_a = PIC.user) !== null && _a !== void 0 ? _a : '',
                subwin: PIC.subwin,
                tableId: 'dispatchTop',
                filterRow: cells
            };
            tmp = sessionStorage.getItem('webSearchTable-Saved-filterRows');
            if (tmp) {
                savedFilterRows = JSON.parse(tmp);
                if (savedFilterRows) {
                    savedFilterRows.find((curFilterRow, idx) => {
                        if (curFilterRow.user == filterRow.user && curFilterRow.subwin == filterRow.subwin && curFilterRow.tableId == curFilterRow.tableId) {
                            foundFilter = idx;
                            return true;
                        }
                    });
                    if (foundFilter >= 0 && savedFilterRows.length >= foundFilter) {
                        savedFilterRows.splice(foundFilter, 1, filterRow);
                    }
                    else {
                        savedFilterRows.push(filterRow);
                    }
                }
                else {
                    savedFilterRows = [filterRow];
                }
            }
            else {
                savedFilterRows = [filterRow];
            }
            sessionStorage.setItem('webSearchTable-Saved-filterRows', JSON.stringify(savedFilterRows));
        }
    }
    ;
    handleTopContextClick(e, orderCont) {
        // use default context for topgrid as everything else is wonk 
        let tmpCont = document.querySelector("pic-context[context-x]");
        if (!tmpCont)
            return;
        tmpCont.shouldHide = false;
        tmpCont.data = { clickEvent: e, context: orderCont, overrideFont: 'sans-serif' };
    }
    handleCalContextClick(e, orderCont) {
        if (orderCont) {
            this.calendarContextMenu.shouldHide = false;
            this.calendarContextMenu.data = { clickEvent: e, context: orderCont, overrideFont: 'sans-serif' };
        }
    }
    renderTopOrderRow(iOrder, index) {
        var _a, _b;
        let valid = validOrder(iOrder);
        let i = 1;
        let canDrag = getDraggable(iOrder, this, valid);
        let orderCont = parseContextArr(iOrder.contextMenu, { callBackFunction: this.refreshData, dispRef: this });
        let docCont = parseContextArr(iOrder.documents, { callBackFunction: this.refreshData, dispRef: this });
        let noteCont = parseContextArr(iOrder.notification, { callBackFunction: this.refreshData, dispRef: this });
        let printCont = parseContextArr(iOrder.documents, { callBackFunction: this.refreshData, dispRef: this });
        return html `
            <div class="top-grid-order top-grid-columns ${canDrag ? 'draggable' : ''}" style="grid-area: ${index + 3} / 1 / ${index + 4} / 26;" 
            draggable=${canDrag}
            @dragstart=${(e) => { if (canDrag) {
            this.handleDrag(e);
        }
        else {
            this.preventDrag(e);
        } }}
            @dragend=${this.handleDragEnd}
            data-actno=${iOrder.actNo + ''}
            data-seqno=${iOrder.seqNo + ''}>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.ref}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.payer}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.invoiceRef}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.transportType}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1}; background-color: var(${iOrder.moveStatusColor}, var(--toms-${(_a = iOrder.moveStatusColor) === null || _a === void 0 ? void 0 : _a.replaceAll('-', '')}));">${iOrder.moveStatus}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.deliveryDate}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.deliveryWindow ? iOrder.deliveryWindow : iOrder.moveTime ? formatTime(iOrder.moveTime) : ''}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.moveLength ? secToStr(iOrder.moveLength) : ''}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.eqId}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.sizeType}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.chassis}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.nW}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.dGS}${valid ? ' - ' : ''}${iOrder.aDR}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.posFrom}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.pickUpRef}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.posTo}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.turnin}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.turninRef}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1}; background-color: var(${iOrder.grossMarginColor}, var(--toms-${(_b = iOrder.grossMarginColor) === null || _b === void 0 ? void 0 : _b.replaceAll('--', '')}));">${iOrder.grossMargin && valid ? iOrder.grossMargin : 0.0}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.note}</div>
                <div @click=${(e) => this.handleTopContextClick(e, orderCont)} class="cell" style="grid-column: ${i} / ${i += 1};">${iOrder.booker}</div>
                <div class="cell svg" style="grid-column: ${i} / ${i += 1};">
                    ${iOrder.documents.length > 0 ? html `
                    <svg class="pic-svg" 
                        @click=${(e) => this.handleTopContextClick(e, docCont)}>
                        <use a="" href="/svg/icons/iconpack.svg#folder" xlink:href="/svg/icons/iconpack.svg#folder"></use>
                    </svg>` : ''}
                </div>
                <div class="cell svg" style="grid-column: ${i} / ${i += 1};">
                    ${iOrder.prints.length > 0 ? html `
                    <svg class="pic-svg"
                        @click=${(e) => this.handleTopContextClick(e, printCont)}>
                        <use a="" href="/svg/icons/iconpack.svg#pdf" xlink:href="/svg/icons/iconpack.svg#pdf"></use>
                    </svg>` : ''}
                </div>
                <div class="cell svg" style="grid-column: ${i} / ${i += 1};">
                    ${iOrder.notification.length > 0 ? html `
                    <svg class="pic-svg"
                        @click=${(e) => this.handleTopContextClick(e, noteCont)}>
                        <use a="" href="/svg/icons/iconpack.svg#notification" xlink:href="/svg/icons/iconpack.svg#notification"></use>
                    </svg>` : ''}
                </div>
            </div>
        `;
        function validOrder(iOrder) {
            return ('actNo' in iOrder && 'seqNo' in iOrder);
        }
        function formatTime(iTime) {
            var _a, _b, _c, _d, _e, _f;
            let spltStr = iTime.split('^');
            if (spltStr[0] == spltStr[1])
                return ((_a = spltStr[0]) === null || _a === void 0 ? void 0 : _a.substr(0, 2)) + ':' + ((_b = spltStr[0]) === null || _b === void 0 ? void 0 : _b.substr(2));
            else
                return ((_c = spltStr[0]) === null || _c === void 0 ? void 0 : _c.substr(0, 2)) + ':' + ((_d = spltStr[0]) === null || _d === void 0 ? void 0 : _d.substr(2)) + ' - ' + ((_e = spltStr[1]) === null || _e === void 0 ? void 0 : _e.substr(0, 2)) + ':' + ((_f = spltStr[1]) === null || _f === void 0 ? void 0 : _f.substr(2));
            ;
        }
        function secToStr(iSec) {
            let hours = Math.floor(iSec / 3600);
            iSec %= 3600;
            return hours + ':' + ('' + Math.floor(iSec / 60)).padStart(2, '0');
        }
        function getDraggable(iOrder, ref, valid) {
            let localDate = new Date();
            localDate.setHours(0, 0, 0, 0);
            if (!valid) {
                return false;
            }
            else if (new Date(ref.globVars.curDate).getTime() < localDate.getTime()) {
                return false;
            }
            else if ('DONE,EXECUTING'.includes(iOrder.moveStatus.toUpperCase())) {
                return false;
            }
            else {
                return true;
            }
        }
    }
    /* leftmost column showing timestamps */
    renderTimeCol() {
        let today = new Date();
        let min = today.getMinutes();
        let searchTime = '';
        if (today.getHours() <= 9)
            searchTime = "0";
        searchTime += today.getHours() + ":";
        if (min < 30)
            searchTime += "00";
        else
            searchTime += "30";
        return html `
            <div class="driverPlaceHolder driverTime grid-hdr">&nbsp;</div>
            ${repeat(this.time, (item, index) => html `
                <div class="grid-item driverTime ${item.txt == searchTime ? 'scrollTarget' : ''}">${item.txt}</div>`)}
        `;
    }
    /* truck columns  */
    renderTruckCol() {
        return html `
            ${repeat(this.trucks, (truck) => truck.id, (truck, index) => this.renderTruck(truck, index))}
        `;
    }
    renderTruck(iTruck, truckIndex) {
        return html `
            ${this.renderTruckHdr(iTruck, truckIndex)}
            ${repeat(this.time, (time, timeIndex) => this.renderTruckSlot(iTruck, truckIndex, time.txt, timeIndex))}
        `;
    }
    renderTruckSlot(iTruck, driverIndex, iTime, timeIndex) {
        return html `<div
                    @drop=${this.handleDrop}
                    @dragover=${this.allowDrop}
                    @dragenter=${this.dragEnter}
                    @dragleave=${this.dragLeave}
                    @click=${(e) => { this.handleCalContextClick(e, parseContextArr(iTruck.slotContext, { callBackFunction: this.refreshData, dispRef: this, extraParms: [{ key: 'itime', val: iTime }, { key: 'ilicense', val: iTruck.licensePlate }] })); }}
                    class=${classMap(getClasses(iTruck, iTime, this))}
                    style="grid-area: ${timeIndex + 1} / ${iTruck.startCol + 2} / ${timeIndex + 2} / ${iTruck.startCol + iTruck.colCount + 2};"
                    title="${iTime}"
                    data-time="${iTime}"
                    data-license="${iTruck.licensePlate}">
                        &nbsp;
                    </div>`;
        function getClasses(iTruck, iTime, iRef) {
            let res = {};
            res['grid-item'] = true;
            res['driverTimeSlot'] = true;
            res[iTruck.licensePlate] = true;
            res['noBottom'] = iRef.nosep_;
            res[iTime] = true;
            res['whitebg'] = iTruck.requestingJob;
            return res;
        }
    }
    renderTruckHdr(iTruck, index) {
        var _a;
        let tmp = parseContextArr(iTruck.context, { callBackFunction: this.refreshData, dispRef: this });
        return html `<div
            class="driverHdr"
            style=" grid-column: ${iTruck.startCol + 2} / ${iTruck.startCol + iTruck.colCount + 2};
                    color: var(${iTruck.driver.status}, var(--toms-${(_a = iTruck.driver.status) === null || _a === void 0 ? void 0 : _a.replaceAll('--', '')}));"
            @click=${(e) => this.handleCalContextClick(e, tmp)}
            >
            ${iTruck.truckID}(${iTruck.driver.driverName}) - ${iTruck.driver.accepted} ${iTruck.truckNote}
        </div>`;
    }
    /* orders rendered on top of the truck grid */
    renderAssignedOrder(iOrder, index) {
        var _a, _b, _c;
        //TODO make this display an error to the user 
        if (((_a = iOrder.placeHelper) === null || _a === void 0 ? void 0 : _a.validPos) == false) {
            return '';
        }
        let col = getCol(iOrder.truck, this) + iOrder.placeHelper.pos;
        let colEnd = col + iOrder.placeHelper.posEnd;
        let rows = iOrder.placeHelper;
        let contextEvents = [];
        if (iOrder.contextMenu)
            iOrder.contextMenu.forEach(cMenu => {
                var _a, _b;
                if (cMenu.eventFncKey) {
                    if (cMenu.eventFncKey === 'loadPage') {
                        cMenu.eventFnc = () => { loadPage(...cMenu.eventTxt.split(',')); };
                    }
                    else if (cMenu.eventFncKey === 'apiRequest') {
                        let data = {};
                        let tmp = cMenu.eventTxt.split(',');
                        let target = tmp[0];
                        if (tmp.length > 1) {
                            let propArr = (_b = (_a = tmp[1]) === null || _a === void 0 ? void 0 : _a.split('$')) !== null && _b !== void 0 ? _b : [];
                            /* replace placeholders with values from current order */
                            propArr.forEach(prop => {
                                if (prop.length !== 0) {
                                    let innerPropArr = prop.substring(prop.indexOf('{') + 1, prop.indexOf('}')).split('|');
                                    let key = innerPropArr[0], val;
                                    if (innerPropArr.length > 1) {
                                        val = innerPropArr[1];
                                    }
                                    else {
                                        //@ts-ignore
                                        val = iOrder[key];
                                    }
                                    if (key && ['actNo', 'seqNo', 'value'].includes(key)) {
                                        val = parseInt(val);
                                    }
                                    //@ts-ignore
                                    data[key] = val;
                                }
                            });
                            //@ts-ignore
                            data['termName'] = this.globVars.termName;
                        }
                        let opts = {
                            postBody: {
                                mode: target,
                                data: data
                            }
                        };
                        cMenu.eventFnc = () => {
                            return fetchApiData('/toms/spedition/speditionapi', opts).then((data) => {
                                if (data && data[0] && data[0].result) {
                                    if (data[0].result == 200) {
                                        console.log('APIREQ went well');
                                        if (data[0].message > '')
                                            doSubmit('', { choiceBox: { hasChoiceBox: true, customBox: { choiceTitle: data[0].message, choices: [{ choiceText: 'Ok', choiceEvent: '' }] } } });
                                        this.refreshData();
                                    }
                                    else if (data[0].result == 400) {
                                        doSubmit('', { choiceBox: { hasChoiceBox: true, customBox: { choiceTitle: data[0].message, choices: [{ choiceText: 'Ok', choiceEvent: '' }] } } });
                                        console.log('400?');
                                        console.log(data);
                                        this.refreshData();
                                    }
                                    else {
                                        console.log(data);
                                        doSubmit('', { choiceBox: { hasChoiceBox: true, customBox: { choiceTitle: 'Unknown error occurred - please try again', choices: [{ choiceText: 'Ok', choiceEvent: '' }] } } });
                                        /*alert('API returned ' + data[0].result + ' handling is not implemented.');*/
                                    }
                                }
                                else {
                                    console.log('caught by safety');
                                }
                            });
                        };
                    }
                }
                contextEvents.push(cMenu);
            });
        let canDrag = getDraggable(iOrder, this);
        if (iOrder.orderType == 'FreePeriod') {
            return html `
            <div 
                @click=${(e) => this.handleCalContextClick(e, contextEvents)}
                class="order ${getOrderClass(iOrder, this, colEnd)} "
                style="${iOrder.classLine ? 'background-color: var(' + iOrder.classLine + ', var(--toms-' + ((_b = iOrder.classLine) === null || _b === void 0 ? void 0 : _b.replaceAll('--', '')) + '));' : ''}
                grid-area: ${rows.start} / ${col} / ${rows.end} / ${colEnd};"
                >
                <b>Free Period: </b>${iOrder.custRef}
            </div>
            `;
        }
        else { //simple view  ref, from, to, turnin
            return html ` 
            <div draggable=${canDrag}
                @click=${(e) => this.handleCalContextClick(e, contextEvents)}
                @dragstart=${(e) => { if (canDrag) {
                this.handleDrag(e);
            }
            else {
                this.preventDrag(e);
            } }}
                @dragend=${this.handleDragEnd}
                class="order ${getOrderClass(iOrder, this, colEnd)} ${canDrag ? 'draggable' : ''}"
                data-actno=${iOrder.actNo + ''}
                data-seqno=${iOrder.seqNo + ''}
                style="${iOrder.classLine ? 'background-color: var(' + iOrder.classLine + ', var(--toms-' + ((_c = iOrder.classLine) === null || _c === void 0 ? void 0 : _c.replaceAll('--', '')) + '));' : ''} grid-area: ${rows.start} / ${col} / ${rows.end} / ${colEnd};"
                title="From: ${iOrder.posFrom}\nTo: ${iOrder.posTo} \nTurnIn: ${iOrder.turnin} \nEquipment ID: ${iOrder.eqId} \nCustomer: ${iOrder.payer} ${['Invoiced', 'Invoiced*', 'Done'].includes(iOrder.moveStatus) ? "\nTime: " + getTime3(iOrder) : ''} ${iOrder.addedDelay ? "\nDelay: " + iOrder.delay : ''} ${iOrder.eqTemp ? "\nTemperature: " + iOrder.eqTemp : ''} ${iOrder.note ? "\nInternal Note: " + iOrder.note : ''} ${iOrder.dGS ? "\nDGS: " + iOrder.dGS : ''}"
                >
                ${(this.displayMode_ === 'expanded') ? getExpandedOrder(iOrder)
                : (this.displayMode_ === 'compact') ? getCompactOrder(iOrder)
                    : getCustomOrder(iOrder, this)}
            </div>
            `;
        }
        function getExpandedOrder(iOrder) {
            return html ` 
                <b>Ref: </b>${iOrder.ref} <br>
                <b>From: </b>${iOrder.posFrom} <br>
                <b>To: </b>${iOrder.posTo} <br> 
                <b>TurnIn: </b>${iOrder.turnin} <br>
                ${iOrder.eqId ? html `<b>Equipment ID: </b>${iOrder.eqId} <br>` : ''}
                ${iOrder.chassis ? html `<b>Chassis: </b>${iOrder.chassis} <br>` : ''}
                <b>Customer: </b>${iOrder.payer} <br>
                <b>Delivery Window: </b>${iOrder.deliveryWindow}<br>
                ${iOrder.note ? html `<b>Internal Note: </b> ${iOrder.note.substring(0, 50)}${iOrder.note.length > 50 ? '...' : ''} <br>` : ''}
                ${['Invoiced', 'Invoiced*', 'Done'].includes(iOrder.moveStatus) ? html `<b>Time: </b>${getTime3(iOrder)} <br>` : ''}
                ${iOrder.addedDelay ? html `<br><b>Delay: </b> ${iOrder.delay}` : ''}
                ${iOrder.eqTemp ? html `<br><b>Temperature: </b> ${iOrder.eqTemp}` : ''}
                ${iOrder.dGS ? html `<br><b>DGS: </b> ${iOrder.dGS}` : ''}
            `;
        }
        function getCompactOrder(iOrder) {
            return html `
                <b>Ref: </b>${iOrder.ref} <br>
                <b>From: </b>${iOrder.posFrom} <br>
                <b>To: </b>${iOrder.posTo} <br>
                <b>TurnIn: </b>${iOrder.turnin} <br>
            `;
        }
        function getCustomOrder(iOrder, dispRef) {
            let res = [];
            dispRef.customFields_.forEach(tubbel => {
                var _a;
                if (tubbel.key in iOrder) {
                    if (tubbel.key == 'note') {
                        res.push(html `<b>${tubbel.disp}: </b> ${(_a = iOrder[tubbel.key]) === null || _a === void 0 ? void 0 : _a.substring(0, 50)}${iOrder[tubbel.key].length > 50 ? '...' : ''} <br>`);
                    }
                    else if (tubbel.key == 'moveStatus') {
                        res.push(html `${['Invoiced', 'Invoiced*', 'Done'].includes(iOrder.moveStatus) ? html `<b>Time: </b>${getTime3(iOrder)} <br>` : ''}`);
                    }
                    else {
                        res.push(html `<b>${tubbel.disp}: </b> ${iOrder[tubbel.key]} <br>`);
                    }
                }
            });
            return html `${res}`;
        }
        function getOrderClass(iOrder, dispRef, iPosEnd) {
            let truck = dispRef.getGlobTruckByLicense(iOrder.truck);
            if (truck.colCount + truck.startCol + 2 == iPosEnd)
                return 'last';
            return '';
        }
        function getTime(iStops) {
            let start, end;
            if (iStops) {
                iStops.forEach(stop => {
                    var _a, _b;
                    if (((_a = stop.stopType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == 'fromstop') {
                        if (stop.arrDT)
                            start = new Date(stop.arrDT);
                    }
                    else if (((_b = stop.stopType) === null || _b === void 0 ? void 0 : _b.toLowerCase()) == 'turninstop') {
                        if (stop.doneDt)
                            end = new Date(stop.doneDt);
                    }
                });
            }
            return timeStampToStr(start) + '-' + timeStampToStr(end);
        }
        function getTime2(iOrder) {
            return timeStampToStr(iOrder.start) + '-' + timeStampToStr(iOrder.end);
        }
        function getTime3(iOrder) {
            if (iOrder.overrideTime)
                return iOrder.overrideTime;
            return timeStampToStr(new Date(parseInt(iOrder.startTime))) + '-' + iOrder.endTime;
        }
        function timeStampToStr(iDate) {
            if (typeof (iDate) === 'string' || iDate instanceof String)
                iDate = new Date(iDate);
            if (iDate && iDate instanceof Date) {
                let h, m;
                h = iDate.getHours();
                m = iDate.getMinutes();
                return (h + '').padStart(2, '0') + (m + '').padStart(2, '0');
            }
            return '0000';
        }
        function getCol(iLicense, dispRef) {
            let res = -1;
            res = dispRef.getGlobTruckByLicense(iLicense).startCol + 2;
            return res;
        }
        ;
        function getDraggable(iOrder, ref) {
            if ('DONE,EXECUTING,INVOICED,INVOICED*'.includes(iOrder.moveStatus.toUpperCase())) {
                return false;
            }
            else {
                return true;
            }
        }
    }
    refreshData(iOptions = null) {
        let iData, iRef = null;
        if (iOptions) {
            if (iOptions.data)
                iData = iOptions.data;
            if (iOptions.dispRef)
                iRef = iOptions.dispRef;
        }
        if (!iData) {
            return fetchApiData('/toms/spedition/speditionapi', iRef ? iRef.apiOpt : this.apiOpt).then((data) => {
                handleApiResponse(data, iRef ? iRef : this);
            }).catch(() => {
                if (this.hasReceivedData)
                    return;
                else if (this.retryHandle > 0) {
                    this.retryHandle--;
                    let ref = this;
                    setTimeout(() => { ref.refreshData(iOptions); }, 500);
                    return;
                }
            });
        }
        else {
            handleApiResponse(iData, iRef ? iRef : this);
        }
        function handleApiResponse(apiData, dispRef) {
            dispRef.hasReceivedData = true;
            console.log(apiData);
            try {
                let tmp = dispRef.assignedOrders;
                dispRef.assignedOrders = apiData.calendarView;
                dispRef.globVars = apiData.globVars;
                dispRef.orders = apiData.topView;
                if (dispRef.orders.length == 0) {
                    dispRef.orders.push({ ref: '-', notification: [], documents: [], prints: [] });
                }
                dispRef.globVars.trucks.sort((t1, t2) => t1.truckID.localeCompare(t2.truckID));
                let tmp2 = dispRef.trucks;
                dispRef.trucks = dispRef.globVars.trucks;
                dispRef.orders.sort((to1, to2) => {
                    if (to1.moveTime && to2.moveTime)
                        return to1.moveTime.split('^')[1].localeCompare(to2.moveTime.split('^')[1]);
                    else
                        return -1;
                });
                dispRef.assignedOrders.sort((ao1, ao2) => {
                    if (ao1.moveLength && ao2.moveLength)
                        return ao2.moveLength - ao1.moveLength;
                    else
                        return -1;
                });
                dispRef.assignedOrders.forEach(order => {
                    order.placeHelper = getOrderPlacement(order, dispRef);
                });
                setColCounts(dispRef);
                dispRef.requestUpdate('assignedOrders', tmp);
                dispRef.requestUpdate('trucks', tmp2);
            }
            catch (error) {
                PIC.getInstance.error.addError(error);
            }
            function setColCounts(dr) {
                let tot = 0;
                if (dr.trucks.length) {
                    dr.trucks.forEach(t => {
                        t.startCol = tot;
                        if (dr.displayMode_ == 'expanded' || dr.displayMode_ == 'customexpanded')
                            t.colCount = Math.max(5, t.slotHelper ? t.slotHelper.length : 1);
                        else
                            t.colCount = t.slotHelper ? t.slotHelper.length : 1;
                        //t.colCount = (t.slotHelper ? Math.max(...t.slotHelper) : 1);
                        tot += t.colCount;
                    });
                }
                else {
                    tot = 1;
                }
                dr.colCount = tot;
            }
            function getOrderPlacement(iOrder, dispRef) {
                let res = getRows(iOrder, dispRef);
                res.pos = 0;
                res.validPos = true;
                let truck = dispRef.getGlobTruckByLicense(iOrder.truck);
                if (!truck) {
                    return { start: 0, end: 0, pos: 0, posEnd: 0, validPos: false };
                }
                let length = truck.slotHelper ? truck.slotHelper.length : 1;
                let fitArr = new Array(length).fill(0);
                if (truck) {
                    if (!truck.slotHelper) {
                        //init
                        truck.slotHelper = [];
                        truck.slotHelper.push(new Array(50).fill(0));
                    }
                    for (let i = res.start; i < res.end; i++) {
                        for (let j = 0; j < truck.slotHelper.length; j++) {
                            fitArr[j] += truck.slotHelper[j][i];
                        }
                    }
                }
                let idx;
                if (fitArr.includes(0)) {
                    idx = fitArr.indexOf(0);
                }
                else {
                    idx = truck.slotHelper.length;
                    truck.slotHelper.push(new Array(50).fill(0));
                }
                for (let i = res.start; i < res.end; i++) {
                    if (truck.slotHelper[idx])
                        truck.slotHelper[idx][i]++;
                    else
                        console.log(iOrder, truck);
                }
                res.pos = idx;
                res.posEnd = 1;
                return res;
                function getRows(iOrder, dispRef) {
                    let res = { start: 0, end: 0, pos: 0 };
                    let start = new Date(iOrder.start);
                    let end = new Date(iOrder.end);
                    if (equalDates(start, end)) {
                        res.start = timeStamp2RowNo(start);
                        res.end = timeStamp2RowNo(end);
                    }
                    else if (equalDates(dispRef.curDateObj_, start)) {
                        res.start = timeStamp2RowNo(start);
                        res.end = 49;
                    }
                    else if (equalDates(dispRef.curDateObj_, end)) {
                        res.start = 1;
                        res.end = timeStamp2RowNo(end);
                    }
                    else {
                        res.start = 1;
                        res.end = 49;
                    }
                    if (res.start == res.end)
                        res.end += 1;
                    return res;
                    function equalDates(d1, d2) {
                        return (d1.getFullYear() == d2.getFullYear() && d1.getMonth() == d2.getMonth() && d1.getDate() == d2.getDate());
                    }
                    function timeStamp2RowNo(iDate) {
                        let h = 1 + (iDate.getHours() * 2);
                        let m = iDate.getMinutes();
                        if (m < 15) {
                            m = 0;
                        }
                        else if (m >= 15 && m < 45) {
                            m = 1;
                        }
                        else if (m >= 45) {
                            m = 2;
                        }
                        return h + m;
                    }
                }
            }
        }
    }
    preventClose(e, contextMenu) {
        if (contextMenu)
            contextMenu.shouldHide = false;
    }
    clearSearch(e) {
        for (let i = 0; i < this.searchFields.length; i++) {
            let elem = this.searchFields[i];
            elem.value = '';
            elem.dispatchEvent(new CustomEvent('keyup'));
        }
    }
    renderClearButton() {
        return html `
            <div class="clearSearchBTN" @click="${this.clearSearch}">Clear search filters</div>
        `;
    }
    render() {
        return html `
            <pic-context globflag="ignoreScroll" id="pic-top-contextMenu"></pic-context>
            ${this.renderClearButton()}
            <div class="heightcontainer">
                <div 
                    class="top-grid top-grid-columns" 
                    id="topgrid" 
                    style="--numJobs:${this.orders.length};"
                    @scroll=${(e) => {
            this.preventClose(e, document.querySelector("pic-context[context-x]"));
            this.setSaveScrolltop();
        }}>
                    ${this.renderTopOrderHdr()}
                    ${repeat(this.orders, (order) => order.actNo, (order, index) => this.renderTopOrderRow(order, index))}
                </div>
                <div 
                    class="grid-container" 
                    id="gridContainer" 
                    style="grid-template-columns: 3rem repeat(${this.colCount}, 1fr);" 
                    @scroll=${(e) => {
            this.preventClose(e, this.calendarContextMenu),
                this.setSaveScrolltop();
        }}>
                        ${this.renderTimeCol()}
                        ${this.renderTruckCol()}
                        ${repeat(this.assignedOrders, (ttmove) => ttmove.ref, (ttmove, index) => this.renderAssignedOrder(ttmove, index))}
                        <pic-context mode="table" globflag="ignoreScroll" id="pic-disp-contextMenu"></pic-context>
                </div>
            </div>
        `;
    }
};
__decorate([
    query('#pic-disp-contextMenu')
], PICDispatch.prototype, "calendarContextMenu", void 0);
__decorate([
    queryAll('.top-grid-order')
], PICDispatch.prototype, "topOrders", void 0);
__decorate([
    queryAll('.top-grid-hdr-inp')
], PICDispatch.prototype, "topSearch", void 0);
__decorate([
    queryAll('.top-grid-hdr-inp-field')
], PICDispatch.prototype, "searchFields", void 0);
__decorate([
    query('#gridContainer')
], PICDispatch.prototype, "calendarGridContainer", void 0);
__decorate([
    query('#topgrid')
], PICDispatch.prototype, "topViewGridContainer", void 0);
__decorate([
    query('.scrollTarget')
], PICDispatch.prototype, "scrollTarget", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICDispatch.prototype, "globMode", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICDispatch.prototype, "viewMode", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICDispatch.prototype, "curDate", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICDispatch.prototype, "term", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICDispatch.prototype, "truckGrp", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'displaymode' })
], PICDispatch.prototype, "displayMode_", void 0);
__decorate([
    property({ converter: numberDecoder, reflect: true })
], PICDispatch.prototype, "topViewScrollTop", void 0);
__decorate([
    property({ converter: numberDecoder, reflect: true })
], PICDispatch.prototype, "calendarScrollTop", void 0);
__decorate([
    property({ converter: objectDecoder, attribute: 'customfields' })
], PICDispatch.prototype, "customFields_", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'disableseperators' })
], PICDispatch.prototype, "nosep_", void 0);
PICDispatch = __decorate([
    customElement('pic-dispatch')
], PICDispatch);
export { PICDispatch };
//# sourceMappingURL=PICDispatch.js.map